import {
  HttpEvent,
  HttpErrorResponse,
  HttpStatusCode,
  HttpContextToken,
  HttpContext
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { KeycloakCustomService } from '../services/keycloak-custom.service';
import { environment } from 'src/environments/environment';
import { DataService } from '../services/data.service';
import { ModalService } from '../services/modal-service.service';
import { MatDialog } from '@angular/material/dialog';

const SEND_TOKEN = new HttpContextToken<boolean>(() => true);
export function notSendToken() {
  return new HttpContext().set(SEND_TOKEN, false);
}

@Injectable()
export class TokenCustomInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private keycloakCustomService: KeycloakCustomService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    if (!req.context.get(SEND_TOKEN)) {
      return next.handle(req);
    }

    const isOmit = environment.keycloak.bearerExcludedUrls.some((url) => req.url.includes(url));
    if (isOmit) {
      return next.handle(req); // Omitir la solicitud y continuar sin agregar el token
    }

    let request = req;
    const token = this.keycloakCustomService.token;
    if (token) {
      request = this.addTokenHeader(req, token);
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === HttpStatusCode.Unauthorized &&
          token
        ) {
          return this.handle401Error(request, next);
        }
        return throwError(() => error);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const refreshService = this.keycloakCustomService.doRefreshToken();
      return refreshService.pipe(
        switchMap(({ data }) => {
          const { access_token } = data;
          this.isRefreshing = false;
          this.refreshTokenSubject.next(access_token);
          return next.handle(this.addTokenHeader(request, access_token));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          this.keycloakCustomService.logout();
          return throwError(() => err);
        }),
      );
    }

    return this.refreshTokenSubject.pipe(
      filter((access_token) => access_token !== null),
      take(1),
      switchMap((access_token) => next.handle(this.addTokenHeader(request, access_token)))
    );
  }

  private addTokenHeader(request: HttpRequest<any>, access_token: string) {
    return request.clone({
      headers: request.headers.set('Authorization', `Bearer ${access_token}`),
    });
  }

}
